import { Component, OnInit, Inject, OnDestroy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SettingsService } from '@services/settings/settings.service';
import { ToastService } from '@storybook/services/toast/toast.service';
import { Store } from '@ngrx/store';
import * as fromLinkUpReducer from '@settings/link-up/store/reducers/link-up.reducers';
import { LinkUpActions } from '@settings/link-up/store/actions';
import { onDestroyComplete } from '@app/sharedModule/decorators/on-destroy-unsubscribe.decorator';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ofType, Actions } from '@ngrx/effects';

@Component({
  selector: 'deactivated-workstation',
  templateUrl: './deactivate-workstation-dialog.component.html',
  styleUrls: ['./deactivate-workstation-dialog.component.scss'],
  standalone: false,
})
export class DeactivateWorkstationDialogComponent implements OnInit, OnDestroy {
  workstation;
  isLoading = false;
  @onDestroyComplete() destroy$ = new Subject();

  constructor(
    public dialogRef: MatDialogRef<DeactivateWorkstationDialogComponent>,
    private settingsService: SettingsService,
    private toastService: ToastService,
    private store: Store<fromLinkUpReducer.State>,
    private actions$: Actions,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {}

  ngOnInit(): void {
    this.workstation = this.data.workstation;
    this.detectSuccess();
  }

  ngOnDestroy(): void {}

  detectSuccess() {
    this.actions$.pipe(takeUntil(this.destroy$), ofType(LinkUpActions.deleteLinkUpWorkstationSuccess)).subscribe(() => {
      this.toastService.showToast({ mode: 'info', message: 'Workstation deactivated successfully' });
      this.dialogRef.close();
    });
  }

  deactivate() {
    this.store.dispatch(LinkUpActions.deleteLinkUpWorkstation({ workstationId: this.workstation.id }));
  }
}
